/*
 * @Date: 2026-01-31 10:00:00
 * @Description: 证书相关API - 同步小程序端功能
 */
import { request } from "@/request/request";
import { parameterChange } from "@/utils/utils";

export default {
  // 查询证书列表
  certificateList(data) {
    return request({
      url: "/pms/cohf/userCertificate/list?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 获取证书详细信息
  certificateDetail(data) {
    return request({
      url: "/pms/cohf/userCertificate/get/" + data.id,
      method: "get",
    });
  },
  // 关联证书
  certificateGrant(data) {
    return request({
      url: "/pms/cohf/userCertificate/grant",
      method: "post",
      data,
    });
  },
};
